export const navBarData = [
  {
    name: "Manufacturer List",
    navigatePath: "/healthsy-services/order-medicines/masters/manufacturer",
  },
  {
    name: "Marketers List",
    navigatePath: "/healthsy-services/order-medicines/masters/marketers",
  },
  {
    name: "Salt/Molecule",
    navigatePath: "/healthsy-services/order-medicines/masters/salt-molecules",
  },
  {
    name: "Unit",
    navigatePath: "/healthsy-services/order-medicines/masters/unit",
    className: "career-tab-jobpost career-gender",
  },
  {
    name: "Product Type",
    className: "mx-5",
    navigatePath: "/healthsy-services/order-medicines/masters/product-type",
  },
  {
    name: "Pincode List",
    className: "mx-5",
    navigatePath: "/healthsy-services/order-medicines/masters/pincode-list",
  },
];

export const MoleculeBreadcrumbsList = (title = "", edit = false) => {
  const array = [
    {
      text: "Healthsy Services",
      link: "/healthsy-services/order-medicines/medicine-details",
    },
    {
      text: "Order Medicines",
      link: "/healthsy-services/order-medicines/medicine-details",
    },
    {
      text: "Masters",
      link: "",
    },
    {
      text:
        title === "list"
          ? "Salt / Molecule"
          : edit
            ? "Edit Salt / Molecule"
            : "Add Salt / Molecule",
      link: "",
    },
  ];
  return array;
};

export const UnitBreadcrumbsList = (title = "", edit = false) => {
  const array = [
    {
      text: "Healthsy Services",
      link: "/healthsy-services/order-medicines/medicine-details",
    },
    {
      text: "Order Medicines",
      link: "/healthsy-services/order-medicines/medicine-details",
    },
    {
      text: "Masters",
      link: "",
    },
    {
      text: title === "list" ? "Unit" : edit ? "Edit Unit" : "Add Unit",
      link: "",
    },
  ];

  return array;
};

export const ProductBreadcrumbsList = (title = "", edit = false) => {
  const array = [
    {
      text: "Healthsy Services",
      link: "/healthsy-services/order-medicines/medicine-details",
    },
    {
      text: "Order Medicines",
      link: "/healthsy-services/order-medicines/medicine-details",
    },
    {
      text: "Masters",
      link: "",
    },
    {
      text:
        title === "list"
          ? "Product Type"
          : edit
            ? "Edit Product Type"
            : "Add Product Type",
      link: "",
    },
  ];

  return array;
};

export const ManufacturerBreadcrumbsList = (title = "", edit = false) => {
  const array = [
    {
      text: "Healthsy Services",
      link: "/healthsy-services/order-medicines/medicine-details",
    },
    {
      text: "Order Medicines",
      link: "/healthsy-services/order-medicines/medicine-details",
    },
    {
      text: "Masters",
      link: "",
    },
    {
      text:
        title === "list"
          ? "Manufacturer List"
          : edit
            ? "Edit Manufacturer"
            : "Add Manufacturer",
      link: "",
    },
  ];

  return array;
};

export const MarketersBreadcrumbsList = (title = "", edit = false) => {
  const array = [
    {
      text: "Healthsy Services",
      link: "/healthsy-services/order-medicines/medicine-details",
    },
    {
      text: "Order Medicines",
      link: "/healthsy-services/order-medicines/medicine-details",
    },
    {
      text: "Masters",
      link: "",
    },
    {
      text:
        title === "list"
          ? "Marketers List"
          : edit
            ? "Edit Marketers"
            : "Add Marketers",
      link: "",
    },
  ];

  return array;
};

export const PincodebreadcrumbsList = (title = "", edit = false) => {
  const array = [
    {
      text: "Healthsy Services",
      link: "/healthsy-services/order-medicines/medicine-details",
    },
    {
      text: "Order Medicines",
      link: "/healthsy-services/order-medicines/medicine-details",
    },
    {
      text: "Masters",
      link: "",
    },
    {
      text:
        title === "list"
          ? "Pincode List"
          : edit
            ? "Edit Pincode"
            : "Add Pincode",
      link: "",
    },
  ];

  return array;
};

export const viewMedbreadcrumbsList = (molecule) => {
  return [
    {
      text: "Healthsy Services",
      link: "/healthsy-services/order-medicines/medicine-details",
    },
    {
      text: "Order Medicines",
      link: "/healthsy-services/order-medicines/medicine-details",
    },
    {
      text: "Masters",
      link: "/healthsy-services/order-medicines/masters/salt-molecules",
    },
    { text: molecule, link: "" },
    { text: "View Medicines", link: "" },
  ];
};
